import React from 'react';
import { Box, Typography } from '@mui/material';
import { SupportCard } from './styles';

export default function SupportSection({ helpDeskNumbers }) {
    const numbers = helpDeskNumbers
        ? helpDeskNumbers.split(',').map((n) => n.trim()).filter(Boolean)
        : [];

    return (
        <SupportCard component="section" aria-labelledby="support-title">
            <Typography id="support-title" variant="h6" fontWeight={700} color="#FFFFFF">
                Trouble installing?
            </Typography>
            <Typography variant="body2" color="#94A3B8" sx={{ lineHeight: 1.65 }}>
                Reach out <strong style={{ color: '#CBD5E1' }}>before</strong> your exam — we can&apos;t help once the exam window has started.
            </Typography>
            {numbers.length > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    {numbers.map((num, index, arr) => (
                        <React.Fragment key={index}>
                            <a
                                href={`tel:${num}`}
                                style={{
                                    color: '#93C5FD',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    transition: '0.3s',
                                }}
                                onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                            >
                                {num}
                            </a>
                            {index !== arr.length - 1 && (
                                <Typography component="span" sx={{ color: 'rgba(255,255,255,0.2)', fontSize: '14px' }}>
                                    |
                                </Typography>
                            )}
                        </React.Fragment>
                    ))}
                </Box>
            )}
        </SupportCard>
    );
}
